/* 
  This file contains the api paths. Since we use React Query, we are using the paths as query keys.
  If it's just a mutation and won't be used as a query you can just use the path as a string. 
  If it is a query key, then prefix it with QUERY_

  Also note that there are different api versions used and we specify that as part of the path.
*/

// Auth
export const AUTH_TOKEN = "v02/auth/token";
export const REFRESH_TOKEN = "/v02/auth/token/refresh";
export const CHANGE_PASSWORD = "v02/admin/account/password";

// Plaid
export const QUERY_PLAID_LINK_TOKEN = "v01/plaid/create-link-token";

// Reporting

// General
export const USER = "v02/user";
export const CONTACT_SALES = "v02/support/sales";

// Transfers
export const ACH_TRANSFER = "v01/me/achtransfer/";

// Admin
export const ME_QUERY_KEY = "v02/user/me";
export const QUERY_ONBOARDING_KEY = "v02/admin/onboarding";
export const QUERY_ADMIN_DASHBOARD_KEY = "v02/admin/dashboard";
export const QUERY_ADMIN_DASHBOARD_EMPLOYEES_KEY =
  "v02/admin/dashboard/employees/";
export const QUERY_ADMIN_DASHBOARD_PROGRAMS_KEY =
  "v02/admin/dashboard/programs";
export const QUERY_ADMIN_DASHBOARD_COMPANY_SETTINGS_KEY =
  "v02/admin/dashboard/settings/company";
export const QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY =
  "v02/admin/dashboard/settings/team";
export const COMPLETE_ONBOARDING = "v02/admin/onboarding/complete";
export const ADMIN_TEAM_INVITE = "v02/admin/team/invite";
export const ADMIN_TEAM_INACTIVATE = "v02/admin/team/inactivate";
export const QUERY_ADMIN_REPORT_SUMMARY = "v02/admin/reporting/summary";

// Employees
export const QUERY_ACCOUNT_STATUS = "v01/me/accountstatus";
export const QUERY_ACCOUNT = "v01/me/";
export const QUERY_ACCOUNT_BALANCES = "v02/user/me/balances";
export const QUERY_EXTERNAL_ACCOUNTS = "v01/me/externalaccount/";
export const QUERY_ACH_TRANSFERS_HISTORY = "v01/me/transfers/";
export const QUERY_ACCOUNT_STATEMENTS = "account-statements";
export const QUERY_USER_REFERRALS = "v01/me/referrals";
export const QUERY_SHIPPING_ADDRESS = "v01/me/shippingaddress/";
export const CONFIRM_LAST_FOUR = "v01/me/cards/";
export const ORDER_NEW_CARD = "v01/me/cards/order_new_card/";
export const UPDATE_CONTRIBUTION_AMT = "v01/me/sponsoredsavingsenrollment";
export const QUERY_TRANSACTIONS = "v01/me/transactions/";
